import { findAll } from '../../services/recharge/rechargeService'

const state = {
  recharges: [],
}

const getters = {
  recharges: (state) => state.recharges,
}

const actions = {
  async fetchRecharges({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await findAll(params)
      const { result, total } = await data

      commit('setRecharges', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },
}

const mutations = {
  setRecharges: (state, recharges) => {
    state.recharges = recharges
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
